module.exports = __webpack_public_path__ + "img/photoAlbum4.3df5349b.jpg";